import {NgModule} from '@angular/core';
import {AppConfigService} from '../../../services/config.service';
import {DistributedStreamingRegistryService, StreamingModule} from '../../streaming';
import {AuthStreamingService} from '../../streaming/auth-streaming.service';
import {SecurityStreamingService} from './security-streaming.service';

@NgModule({
    imports: [
        StreamingModule
    ],
    providers: [
        {
            provide: SecurityStreamingService,
            useFactory: (
                         distributedStreamingRegistryService: DistributedStreamingRegistryService,
                         appConfigService: AppConfigService
                     ) => {
                const injector = distributedStreamingRegistryService
                    .getStreamingServiceInjector('marketDataStreaming');

                return new SecurityStreamingService(
                    injector.get(AuthStreamingService),
                    appConfigService
                );
            },
            deps: [DistributedStreamingRegistryService, AppConfigService]
        }
    ]
})
export class SecurityStreamingModule {}
